// removed by extract-text-webpack-plugin
module.exports = {"checkboxGroup":"index__checkboxGroup___1Cxuq"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/SelectionModal/index.less
// module id = 1221
// module chunks = 3